import { render, staticRenderFns } from "./FiscalBill.vue?vue&type=template&id=58e2cdc6&scoped=true&"
import script from "./FiscalBill.vue?vue&type=script&lang=js&"
export * from "./FiscalBill.vue?vue&type=script&lang=js&"
import style0 from "./FiscalBill.vue?vue&type=style&index=0&id=58e2cdc6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58e2cdc6",
  null
  
)

export default component.exports